"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOpenOrdersCounter = exports.getAllRegisteredCurrencies = exports.getRegisteredCurrencyAccount = exports.getOrderVaultAuth = exports.getOrderVault = exports.getMarketVarsAccount = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const Seeds = __importStar(require("./seeds"));
const getMarketplaceProgram_1 = require("./../utils/getMarketplaceProgram");
/**
 * Returns the public key and bump seed for the market variables account
 *
 * @param programId - Deployed program ID for Galactic Marketplace
 */
function getMarketVarsAccount(programId) {
    return __awaiter(this, void 0, void 0, function* () {
        return web3_js_1.PublicKey.findProgramAddress([Seeds.MARKET_VARS_SEED], programId);
    });
}
exports.getMarketVarsAccount = getMarketVarsAccount;
/**
 * Returns the public key and bump seed for an order escrow account.
 *
 * @param programId - Deployed program ID for Galactic Marketplace
 */
function getOrderVault(orderInitializer, tokenMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        return web3_js_1.PublicKey.findProgramAddress([Seeds.ORDER_VAULT_SEED, orderInitializer.toBuffer(), tokenMint.toBuffer()], programId);
    });
}
exports.getOrderVault = getOrderVault;
/**
 * Returns the public key and bump seed for an order escrow authority.
 *
 * @param playerPubkey - Pubkey of order initializer
 * @param programId - Deployed program ID for Galactic Marketplace
 */
function getOrderVaultAuth(playerPubkey, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        return web3_js_1.PublicKey.findProgramAddress([Seeds.ORDER_VAULT_AUTH_SEED, playerPubkey.toBuffer()], programId);
    });
}
exports.getOrderVaultAuth = getOrderVaultAuth;
/**
 * Returns the public key and bump seed for a registered currency account
 *
 * @param programId - Deployed program ID for Galactic Marketplace
 * @param currencyMint - Mint address for registered currency
 */
function getRegisteredCurrencyAccount(programId, currencyMint) {
    return __awaiter(this, void 0, void 0, function* () {
        return web3_js_1.PublicKey.findProgramAddress([Seeds.REGISTERED_CURRENCY_SEED, currencyMint.toBuffer()], programId);
    });
}
exports.getRegisteredCurrencyAccount = getRegisteredCurrencyAccount;
function getAllRegisteredCurrencies(connection, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = (0, getMarketplaceProgram_1.getGmIDL)(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const filter = [
            {
                dataSize: 1686,
            },
        ];
        const registeredCurrencies = yield program.account.registeredCurrency.all(filter);
        const currencyInfo = [];
        for (const currency of registeredCurrencies) {
            const someCurrency = {
                mint: currency.account.tokenMint,
                royalty: currency.account.royalty,
                saVault: currency.account.saCurrencyVault,
            };
            currencyInfo.push(someCurrency);
        }
        return currencyInfo;
    });
}
exports.getAllRegisteredCurrencies = getAllRegisteredCurrencies;
function getOpenOrdersCounter(playerPubkey, depositMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        return web3_js_1.PublicKey.findProgramAddress([
            Seeds.OPEN_ORDERS_COUNTER,
            playerPubkey.toBuffer(),
            depositMint.toBuffer(),
        ], programId);
    });
}
exports.getOpenOrdersCounter = getOpenOrdersCounter;
//# sourceMappingURL=pda_getters.js.map